import {
    createAction,
    createSlice,
    type PayloadAction,
} from '@reduxjs/toolkit';

import type { RootState } from '../root/config.store';
import { initialState, TransportKeyDetails, TransportKeyPayload} from '../../types/transportkey'

// slice
export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        fetchAllisLoading(state) {
            state.loading = true;
        },
        fetchAllSucceeded(state, action: PayloadAction<TransportKeyDetails>) {
            state.data = action.payload;
            state.loading = false;
        },
        fetchAllFailure(state, action: PayloadAction<string>) {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

// Actions
export const userInfoActions = {
    fetchAll: createAction<TransportKeyPayload>(
        `${userSlice.name}/fetchAll`
      ),
    fetchAllisLoading: userSlice.actions.fetchAllisLoading,
    fetchAllSucceeded: userSlice.actions.fetchAllSucceeded,
    fetchAllFailure: userSlice.actions.fetchAllFailure,
};

// Selectors
export const transportKey = (state: RootState): TransportKeyDetails => state.transportKeyDetails?.data;

// Reducer
export default userSlice.reducer;